export default class CardTranslation {

    constructor(title, introduction, help, language){
        this.title = title;
        this.introduction = introduction;
        this.help = help;
        this.language = language;
    }

    getTitle(){
        return this.title;
    }

    getIntroduction(){
        return this.introduction;
    }

    getHelp(){
        return this.help;
    }

    getLanguage(){
        return this.language;
    }
    
    setTitle(title){
        this.title = title;
    }

    setIntroduction(introduction){
        this.introduction = introduction;
    }

    setHelp(help){
        this.help = help;
    }

    setLanguage(language){
        this.language = language;
    }
}